<template>
    <ReviewsPage :on-limited="onNetworkLimited"/>
</template>
<script>
import ReviewsPage from "@common/reviews/ReviewsPage";
export default {
    components: {
        ReviewsPage
    },
    props:{
        onNetworkLimited:{default: false},
    },
}
</script>
